import React, { useEffect, useState } from "react";
import {
  format,
  startOfWeek,
  addDays,
  addWeeks,
  subWeeks,
  isSameDay,
} from "date-fns";
import { connect } from "react-redux";
import moment from "moment";
import { apiConfig } from "../../constants/apiConfig";
import {
  CalendarEventModel,
  GoogleCalendarEventModel,
  ICalenderEvents,
} from "../../models/common/ICalendar";
import {
  getCalenderEventsDetails,
  getGoogleCalenderEventsDetails,
} from "../../action/common/calendarActionCreator";
import { UserRole } from "../../constants/RoleEnum";
import { suiteType } from "../../constants/commonConstants";

const WeekCalendar = (props: ICalenderEvents) => {
  const {
    getCalenderEvents,
    getGoogleCalenderEvents,
    events,
    googleEvents,
    email,
    role,
  } = props;

  const [calendarBaseUrl, setClaendarBaseUrl] = useState<string>();
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [currentWeek, setCurrentWeek] = useState<Date>(startOfWeek(new Date()));
  const [lastDayOfWeek, setLastDayOfWeek] = useState<Date>(
    addDays(startOfWeek(new Date()), 6)
  );
  const [dateEvents, setDateEvents] = useState<CalendarEventModel[]>([]);
  const [dateGoogleEvents, setGoogleDateEvents] = useState<
    GoogleCalendarEventModel[]
  >([]);
  const [suite] = useState<suiteType>(apiConfig.suite as suiteType);

  const convertedDateTime = (date: any) => {
    const reversedDate = moment.utc(date).local().format("hh:mm A");
    return reversedDate;
  };

  const handlePrevWeek = () => {
    const prevWeek = subWeeks(currentWeek, 1);
    setCurrentWeek(prevWeek);
    setLastDayOfWeek(addDays(prevWeek, 6));
  };

  const handleNextWeek = () => {
    const nextWeek = addWeeks(currentWeek, 1);
    setCurrentWeek(nextWeek);
    setLastDayOfWeek(addDays(nextWeek, 6));
  };

  useEffect(() => {
    suite == suiteType.google &&
      setClaendarBaseUrl(apiConfig.googleCalendarBaseUrl + email);
    suite == suiteType.microsoft &&
      setClaendarBaseUrl(apiConfig.outlookCalendarBaseUrl);
  }, [suite]);

  useEffect(() => {
    if (email) {
      const startDateTime = moment(currentWeek).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      const endDateTime = moment(lastDayOfWeek).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      if (suite == suiteType.google) {
        getGoogleCalenderEvents(startDateTime, endDateTime, email);
      } else {
        getCalenderEvents(startDateTime, endDateTime, email);
      }
    }
  }, [
    currentWeek,
    lastDayOfWeek,
    email,
    role,
    getCalenderEvents,
    getGoogleCalenderEvents,
  ]);

  useEffect(() => {
    suite == suiteType.google
  ? (() => {
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      const filteredEvents = googleEvents?.filter(
        (event) =>
          moment(event.start.dateTime).format("YYYY-MM-DD") === formattedDate
      );
      setGoogleDateEvents(filteredEvents);
    })()
  : (() => {
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      const filteredEvents = events?.filter(
        (event) =>
          moment(event.start.dateTime).format("YYYY-MM-DD") === formattedDate
      );
      setDateEvents(filteredEvents);
    })();
  }, [selectedDate, events, googleEvents, role]);

  const renderDaysOfWeek = () => {
    return Array.from({ length: 7 }).map((_, i) => {
      const day = addDays(currentWeek, i);
      const isToday = isSameDay(day, selectedDate);
      return (
        <div
          key={i}
          className={`week-day ${isToday ? "selected" : ""}`}
          onClick={() => setSelectedDate(day)}
        >
          <span>{format(day, "dd")}</span>
          <span>{format(day, "EEE")}</span>
        </div>
      );
    });
  };

  return (
    <div className="card-wrap">
      <div className="calendar">
        <div className="calendar-container">
          <div className="header-calendar">
            <h2 id="month-year">{format(currentWeek, "MMMM yyyy")}</h2>
            <button
              id="prev-week"
              className="btn-arrow"
              onClick={handlePrevWeek}
            >
              <i className="fa-solid fa-angle-left"></i>
            </button>
            <button
              id="next-week"
              className="btn-arrow"
              onClick={handleNextWeek}
            >
              <i className="fa-solid fa-angle-right"></i>
            </button>
          </div>

          <div className="d-flex align-items-center justify-content-between">
            <div className="week-container w-100">{renderDaysOfWeek()}</div>
          </div>

          <div className="event-list">
            <h3>
              Events for{" "}
              <span id="selected-day">
                {format(selectedDate, "MM-dd-yyyy")}
              </span>
            </h3>
            {!(suite == suiteType.google)? (
              <div id="event-container-1">
                {dateEvents?.length > 0 ? (
                  dateEvents
                    .sort(
                      (a, b) =>
                        new Date(a.start.dateTime).getTime() -
                        new Date(b.start.dateTime).getTime()
                    )
                    .map((event, index) => (
                      <div key={index} className="event">
                        <h2>{event.subject}</h2>
                        <h4
                          className="para-hide-2"
                          dangerouslySetInnerHTML={{
                            __html: event.bodyPreview
                              .replace(/[\r\n]*_{2,}[\s\S]*/, "")
                              .trim(),
                          }}
                        />
                        <p>
                          <strong>Time: </strong>
                          {convertedDateTime(event.start.dateTime)} -{" "}
                          {convertedDateTime(event.end.dateTime)}
                        </p>
                        <p className="person">
                          <strong>Location: </strong>
                          {event.location.displayName}
                        </p>
                      </div>
                    ))
                ) : (
                  <div className="event no-events-card">
                    <p>No events for this day.</p>
                  </div>
                )}
              </div>
            ) : (
              <div id="event-container" className="stude-eventlist">
                {dateGoogleEvents?.length > 0 ? (
                  dateGoogleEvents
                    .sort(
                      (a, b) =>
                        new Date(a.start.dateTime).getTime() -
                        new Date(b.start.dateTime).getTime()
                    )
                    .map((event, index) => (
                      <div key={index} className="event">
                        <div className="desc">
                          <h2
                            dangerouslySetInnerHTML={{
                              __html: event.summary,
                            }}
                          />
                          <h4
                            className="para-hide-2"
                            dangerouslySetInnerHTML={{
                              __html: event.description,
                            }}
                          />
                          <p className="date">
                            <strong>Time: </strong>
                            {convertedDateTime(event.start.dateTime)} -{" "}
                            {convertedDateTime(event.end.dateTime)}
                          </p>
                          <p className="date">
                            <strong>Location: </strong>
                            {event.location && event.location.trim() !== ""
                              ? event.location
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="text-nowrap">No events for this day.</div>
                )}
              </div>
            )}
          </div>
          <a href={calendarBaseUrl} target="_blank" rel="noopener noreferrer">
            <button className="btn btn-primary">View Entire Schedule</button>
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  events: state.calendar.calenderEvents || [],
  email: state.userDetails.userProfileData?.email || "",
  googleEvents: state.calendar.googleCalenderEvents,
  role: state.userDetails.userProfileData?.currentRole,
});

const mapDispatchToProps = {
  getCalenderEvents: (
    startDateTime: string,
    endDateTime: string,
    userEmail: string
  ) => getCalenderEventsDetails(startDateTime, endDateTime, userEmail),
  getGoogleCalenderEvents: (
    startDateTime: string,
    endDateTime: string,
    userEmail: string
  ) => getGoogleCalenderEventsDetails(startDateTime, endDateTime, userEmail),
};

export default connect(mapStateToProps, mapDispatchToProps)(WeekCalendar);
